"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderButton = exports.Root = exports.NavigationArrowsRoot = exports.Header = exports.CarouselComponent = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _hooks = require("./hooks");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(_hooks.PRODUCTS_GAP),
  height: '100%',
  paddingTop: theme.spacing(6),
  width: '100%'
}));
const Header = exports.Header = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(_hooks.PRODUCTS_GAP),
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6)
  },
  '&:empty': {
    display: 'none'
  }
}));
const CarouselComponent = exports.CarouselComponent = (0, _mui.styled)(_presentationComponents.Carousel, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['mobileHeight', 'desktopHeight', 'enableGrabCursor'])
})(({
  enableGrabCursor,
  mobileHeight,
  desktopHeight,
  theme
}) => ({
  height: mobileHeight,
  [theme.breakpoints.up('md')]: {
    height: desktopHeight
  },
  [`.${_presentationComponents.SLIDER_CLASSNAME}`]: {
    cursor: enableGrabCursor ? 'grab' : 'inherit',
    height: '100%'
  }
}));
const SliderButton = exports.SliderButton = (0, _mui.styled)('button', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  visible
}) => ({
  backgroundColor: 'inherit',
  color: 'inherit',
  display: 'flex',
  padding: 0,
  visibility: visible ? 'visible' : 'hidden',
  svg: {
    height: 24,
    width: 24
  }
}));
const NavigationArrowsRoot = exports.NavigationArrowsRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  height: _hooks.PAGINATION_HEIGHT,
  justifyContent: 'center'
}));
